import React from "react";

interface UnderlineInputProps {
  label: string;
  value?: string;
  disabled?: boolean;
}

const UnderlineInput: React.FC<UnderlineInputProps> = ({ label, value, disabled = false }) => {
  return (
    <div className="mb-3 underline-input-wrapper">
      {/* Label */}
      <div className={`text-muted small-text `}>{label}</div>

      {/* Value */}
      <input
        type="text"
        value={value}
        disabled={disabled}
        readOnly
        className={`form-control underline-input ${value === "Expired" ? "expired-text" : ""}`}
      />
    </div>
  );
};

export default UnderlineInput;
